import Vue from 'vue';
import { set, find, remove, changeOrder, reorderTopics } from '../../../helpers/tree';
import { getParentOfSelectedTopic } from '@/helpers/tree';

function getExpandedTopic(topics, expandedTopicId) {
  for (const topic of topics) {
    if (topic.id === expandedTopicId) {
      return topic;
    }

    if (topic.children) {
      const foundTopic = getExpandedTopic(topic.children, expandedTopicId);

      if (foundTopic) {
        return foundTopic;
      } else {
        continue;
      }
    }
  }
}

export default {
  SET_MENU(state, data) {
    set(data.topics, 'isEditing', false);
    state.context = data.content;
    state.menuTopics = data.topics;
    state.userContext = data.user;
  },
  SET_SELECTED_TOPIC_WITH_CONTENT(state, topic) {
    state.selectedTopic = topic;
  },
  SET_NEW_TOPIC_IN_MENU(state, topic) {
    if (!topic.parentTopicId) {
      state.menuTopics.push(topic);
    } else {
      const index = state.menuTopics.findIndex(item => item.id === topic.parentTopicId);

      if (index > -1) {
        if (state.menuTopics[index].children) {
          state.menuTopics[index].children.push(topic);
        } else {
          Vue.set(state.menuTopics[index], 'children', [topic]);
        }
      } else {
        state.menuTopics.some((firstLevelTopics, firstLevelIndex) => {
          if (firstLevelTopics.children) {
            const index = firstLevelTopics.children.findIndex(item => item.id === topic.parentTopicId);

            if (index > -1) {
              if (state.menuTopics[firstLevelIndex].children[index].children) {
                state.menuTopics[firstLevelIndex].children[index].children.push(topic);
              } else {
                Vue.set(state.menuTopics[firstLevelIndex].children[index], 'children', [topic]);
              }

              return true;
            } else {
              firstLevelTopics.children.some((secondLevelTopics, secondLevelIndex) => {
                if (secondLevelTopics.children) {
                  const index = secondLevelTopics.children.findIndex(item => item.id === topic.parentTopicId);

                  if (index > -1) {
                    if (state.menuTopics[firstLevelIndex].children[secondLevelIndex].children[index].children) {
                      state.menuTopics[firstLevelIndex].children[secondLevelIndex].children[index].children.push(topic);
                    } else {
                      Vue.set(state.menuTopics[firstLevelIndex].children[secondLevelIndex].children[index], 'children', [topic]);
                    }

                    return true;
                  }
                }
              });
            }
          }
        });
      }
    }
  },
  DELETE_TOPIC(state, topic) {
    if (state.selectedTopic.id === topic.id || state.selectedTopic.parentTopicId === topic.id || getParentOfSelectedTopic(state.menuTopics, state.selectedTopic).parentTopicId === topic.id) {
      state.selectedTopic = {};
    } else if (state.selectedTopic.id === topic.parentTopicId) {
      const index = state.selectedTopic.children && state.selectedTopic.children.findIndex(item => item.id === topic.id);

      if (index > -1) {
        state.selectedTopic.children.splice(index, 1);
      }
    }

    remove(state.menuTopics, 'id', topic.id);
    reorderTopics(state.menuTopics, topic);
  },
  UPDATE_TOPIC_IN_MENU(state, { topic, newElement }) {
    if (state.selectedTopic.id === topic.id) {
      if (newElement && newElement.parentTopicId === state.selectedTopic.id) {
        if (state.selectedTopic.children) {
          state.selectedTopic.children.push(newElement);
        } else {
          Vue.set(state.selectedTopic, 'children', [newElement]);
        }
      };

      Object.assign(state.selectedTopic, topic);
    } else if (state.selectedTopic.children) {
      const index = state.selectedTopic.children.findIndex(item => item.id === topic.id);

      if (index > -1) {
        Object.assign(state.selectedTopic.children[index], topic);
      }
    }

    const topicMenu = find(state.menuTopics, 'id', topic.id);
    Object.assign(topicMenu, topic);

    return true;
  },
  UPDATE_GRADE_BOOK_MODULE(state, { topicId, content }) {
    const keys = Object.keys(content);
    const topicMenu = find(state.menuTopics, 'id', topicId);
    keys.forEach(key => {
      topicMenu.content[key] = content[key];
      state.selectedTopic.content[key] = content[key];
    });

    return true;
  },
  UPDATE_WEBCONFERENCE_INTEGRATION_IN_MENU(state, { topicId, value }) {
    const topicMenu = find(state.menuTopics, 'id', topicId);
    Vue.set(topicMenu, 'isWebconferenceIntegrated', value);
  },
  SET_CONTENT_IN_SELECTED_TOPIC(state, topic) {
    const keys = Object.keys(topic.content);

    if (state.selectedTopic.id !== topic.topicId && state.selectedTopic.children) {
      const index = state.selectedTopic.children.findIndex(item => item.id === topic.topicId);

      if (index > -1) {
        keys.forEach(key => {
          state.selectedTopic.children[index].content[key] = topic.content[key];
        });
      }
    } else {
      keys.forEach(key => {
        state.selectedTopic.content[key] = topic.content[key];
      });
    }
  },
  SET_GRADE_BOOK_DETAIL_IN_CHILDREN_SELECTED_TOPIC(state, { gradeBookId, gradeBookItens, participationWeight }) {
    if (state.selectedTopic.children) {
      state.selectedTopic.content.participationWeight = participationWeight;
      for (const children of state.selectedTopic.children) {
        children.gradeBookDetail = [];
        children.gradeBookDetail.push(
          ...gradeBookItens.filter(gradeBookDetail => gradeBookDetail.topicId === children.id)
            .map(gradeBookDetail => {
              return {
                gradeBookId : gradeBookId,
                id          : gradeBookDetail.id,
                type        : gradeBookDetail.type,
                weight      : Number(gradeBookDetail.weight)
              };
            })
        );
      }
    }

    const topicMenu = find(state.menuTopics, 'id', state.selectedTopic.id);

    if (topicMenu && topicMenu.content) {
      topicMenu.content.participationWeight = participationWeight;
    }
  },
  CLEAR_SELECTED_TOPIC(state) {
    state.selectedTopic = {};
  },
  BEFORE_DESTROY_CONTENT(state) {
    state.selectedTopic = {};
    state.context       = {};
    state.menuTopics    = [];
    state.userContext   = {};
  },
  CLEAR_SELECTED_MENU_TOPICS(state) {
    state.menuTopics = [];
  },
  SET_IS_STUDENT_VIEW(state, payload) {
    state.isStudentView = payload;
  },
  SET_TOPIC_VIEWED_ON_MENU(state, { topicId, viewed }) {
    const topic = find(state.menuTopics, 'id', topicId);

    if (topic) {
      topic.viewed = viewed;
    }
  },
  SET_VIEWED_TOPIC_ID(state, id) {
    state.viewedTopicId = id;
  },
  CLEAR_QUESTIONS_GRADE(state, topicId) {
    if (state.selectedTopic.id !== topicId && state.selectedTopic.children) {
      const index = state.selectedTopic.children.findIndex(item => item.id === topicId);

      if (index > -1) {
        state.selectedTopic.children[index].content.questions.forEach(question => {
          question.grade = 0;
        });
      }
    } else if (state.selectedTopic.id === topicId) {
      state.selectedTopic.content.questions.forEach(question => {
        question.grade = 0;
      });
    }
  },
  CHANGE_SEQUENCE_OF_TOPIC(state, { element, oldIndex, newIndex, layout }) {
    if (!element.parentTopicId) {
      state.menuTopics.splice(newIndex, 0, state.menuTopics.splice(oldIndex, 1)[0]);

      state.menuTopics.map((item, index) => {
        item.sequence = index + 1;
      });
    } else {
      changeOrder(state.menuTopics, element, oldIndex, newIndex, layout);
    }

    if (state.selectedTopic.id === element.parentTopicId) {
      state.selectedTopic.layout = layout;
    }
  },
  TOGGLE_IS_EXPANDED_TOPIC(state, { topicId, value }) {
    const topic = getExpandedTopic(state.menuTopics, topicId);

    topic.isExpanded = value;
  },
  SET_VERSION(state, version) {
    state.context.version = version;
  },
  SET_MULTIPLE_GRADES_ON_QUIZ(state, topic) {
    if (state.selectedTopic.id === topic.topicId) {
      topic.questions.forEach(questionUpdated => {
        const index = state.selectedTopic.content.questions.findIndex(question => question.id === questionUpdated.id);

        if (index > -1) {
          state.selectedTopic.content.questions[index].grade = questionUpdated.grade;
        }
      });
    } else if (state.selectedTopic.children && state.selectedTopic.children.findIndex(children => children.id === topic.topicId) > -1) {
      const index = state.selectedTopic.children.findIndex(children => children.id === topic.topicId);

      topic.questions.forEach(questionUpdated => {
        const indexQuestion = state.selectedTopic.children[index].content.questions.findIndex(question => question.id === questionUpdated.id);

        if (index > -1) {
          state.selectedTopic.children[index].content.questions[indexQuestion].grade = questionUpdated.grade;
        }
      });
    }
  },
  SET_NEW_LAYOUT(state, { topic, layout }) {
    if (topic.parentTopicId === state.selectedTopic.id) {
      state.selectedTopic.layout = layout;
    }

    const topicMenu = find(state.menuTopics, 'id', topic.parentTopicId);

    if (topicMenu) {
      topicMenu.layout = layout;
    }
  },
  SET_PENDING_EVALUATIONS(state, pendingEvaluations) {
    if (pendingEvaluations) {
      state.selectedTopic.content.pendingEvaluations = pendingEvaluations;
    }
  }
};
